angular.module('manufacturing')
    .service('ManufacturingOrderAcceptanceService', function ($q, Principal, VehicleLocation) {
        const userPromise = Principal.currentUser()
        const locationPromises = {}

        const loadLocation = locationId => {
            if (locationId == null) return $q.when(null)
            if (!locationPromises[locationId]) locationPromises[locationId] = VehicleLocation.get({id: locationId}).$promise
            return locationPromises[locationId]
        }

        this.location = locationId => $q.all({user: userPromise, location: loadLocation(locationId)}).then(result => {
            const users = result.location && result.location.users || []
            const managers = result.location && result.location.managers || []
            const canChange = users.some(user => user.id === result.user.id) || managers.some(user => user.id === result.user.id)
            return {canChange: canChange, acceptance: canChange ? null : {required: true, status: 'PENDING'}}
        })

        this.transport = transport => {
            const location = transport && transport.vehicle && transport.vehicle.bookingSettings && transport.vehicle.bookingSettings.location
            if (!location) return $q.when({locationId: null, locationName: null, canChange: false})
            return this.location(location.id).then(context => ({locationId: location.id, locationName: location.name, canChange: context.canChange}))
        }

        this.transportAcceptance = (orderLocationId, transportContext) => {
            if (orderLocationId == null || !transportContext || transportContext.locationId == null || orderLocationId === transportContext.locationId) return null
            return {required: true, status: transportContext.canChange ? 'ACCEPTED' : 'PENDING'}
        }
    })
    .controller('ManufacturingOrderBatchEditController', function ($scope, $rootScope, $uibModalInstance, data, ManufacturingOrder, ManufacturingOrderAcceptanceService, ManufacturingOrderVehicleConflictService, Product, Client) {
        let itemSequence = 0
        const source = angular.copy(data.properties || {})
        const createItem = template => ({
            key: ++itemSequence,
            location: angular.copy(template.location) || null,
            nodes: angular.copy(template.nodes || []),
            product: angular.copy(template.product) || null,
            quantityOrdered: template.quantityOrdered,
            technologyRequirements: angular.copy(template.technologyRequirements || {}),
            transport: angular.copy(template.transport || {}),
            notes: template.notes,
            usesSharedNotes: template.usesSharedNotes !== false,
            detailsExpanded: false,
            locationAcceptance: angular.copy(template.locationAcceptance) || null,
            transportAcceptance: angular.copy(template.transportAcceptance) || null,
            canChangeLocationAcceptance: false,
            transportContext: {locationId: null, locationName: null, canChange: false}
        })

        this.shared = {
            client: source.client || null,
            clientStatusAcceptance: source.clientStatusAcceptance,
            deliveryAddress: source.deliveryAddress || {},
            deliveryTime: source.deliveryTime,
            notes: source.notes
        }
        this.addressClients = []
        this.items = [createItem(source)]

        const insertItem = (template, index) => {
            const item = createItem(template)
            this.items.splice(index, 0, item)
            if (item.location) this.updateLocationAcceptance(item)
            this.onTransportChanged(item)
            this.updateSummaries()
        }

        this.$onInit = () => {
            if (this.shared.client) this.loadClient(this.shared.client.id)
            this.items.forEach(item => {
                if (item.location) this.updateLocationAcceptance(item)
                this.onTransportChanged(item)
            })
            this.updateSummaries()
        }

        this.addItem = () => insertItem({notes: this.shared.notes}, this.items.length)

        this.duplicateItem = item => insertItem(item, this.items.indexOf(item) + 1)

        this.removeItem = item => {
            if (this.items.length <= 1) return
            this.items = this.items.filter(existing => existing !== item)
            this.updateSummaries()
        }

        this.loadClient = clientId => {
            this.addressClients = []
            if (clientId == null) {
                this.client = null
                this.clientStatusAcceptanceRequired = false
                return
            }
            return Client.get({id: clientId}).$promise.then(client => {
                if (!this.shared.client || this.shared.client.id !== clientId) return
                this.client = client
                this.addressClients = [client]
                this.clientStatusAcceptanceRequired = client.status !== 'ACTIVE'
                if (this.clientStatusAcceptanceRequired && !this.shared.clientStatusAcceptance) this.shared.clientStatusAcceptance = {}
            })
        }

        this.onClientChanged = () => {
            delete this.shared.clientStatusAcceptance
            return this.loadClient(this.shared.client && this.shared.client.id)
        }

        this.onClientStatusAcceptanceChanged = () => {
            if (this.shared.clientStatusAcceptance.confirmation === true) this.shared.clientStatusAcceptance.status = this.shared.client.status
            else delete this.shared.clientStatusAcceptance.status
        }

        this.onLocationChanged = item => {
            item.nodes = []
            this.updateSummaries()
            return this.updateLocationAcceptance(item)
        }

        this.updateLocationAcceptance = item => {
            item.locationAcceptance = null
            item.canChangeLocationAcceptance = false
            const locationId = item.location && item.location.id
            this.updateTransportAcceptance(item)
            if (locationId == null) return
            return ManufacturingOrderAcceptanceService.location(locationId).then(context => {
                if (!item.location || item.location.id !== locationId) return
                item.canChangeLocationAcceptance = context.canChange
                item.locationAcceptance = context.acceptance
            })
        }

        this.toggleLocationAcceptance = item => {
            item.locationAcceptance = item.locationAcceptance == null ? {required: true, status: 'PENDING'} : null
        }

        this.onTransportChanged = item => {
            this.checkVehicleConflict(item)
            return ManufacturingOrderAcceptanceService.transport(item.transport).then(context => {
                item.transportContext = context
                this.updateTransportAcceptance(item)
            })
        }

        this.updateTransportAcceptance = item => {
            item.transportAcceptance = ManufacturingOrderAcceptanceService.transportAcceptance(item.location && item.location.id, item.transportContext)
        }

        this.toggleTransportAcceptance = item => {
            if (!item.transportAcceptance) return
            item.transportAcceptance.status = item.transportAcceptance.status === 'PENDING' ? 'ACCEPTED' : 'PENDING'
        }

        this.toggleExternalTransport = item => {
            item.transport = item.transport.externalVehicle ? {} : {externalVehicle: true}
            this.onTransportChanged(item)
        }

        this.checkVehicleConflict = item => {
            const request = item.vehicleConflictRequest = (item.vehicleConflictRequest || 0) + 1
            item.vehicleConflict = null
            const vehicle = item.transport && !item.transport.externalVehicle ? item.transport.vehicle : null
            return ManufacturingOrderVehicleConflictService.check(vehicle, this.shared.deliveryTime).then(conflict => {
                if (request === item.vehicleConflictRequest) item.vehicleConflict = conflict
            })
        }

        this.checkVehicleConflicts = () => this.items.forEach(this.checkVehicleConflict)

        this.hasVehicleConflicts = () => this.items.some(item => item.vehicleConflict)

        this.toggleDetails = item => item.detailsExpanded = !item.detailsExpanded

        this.applySharedNotes = () => this.items.filter(item => item.usesSharedNotes).forEach(item => item.notes = this.shared.notes)

        this.onItemNotesChanged = item => item.usesSharedNotes = false

        this.useSharedNotes = item => {
            item.notes = this.shared.notes
            item.usesSharedNotes = true
        }

        this.refreshProducts = search => Product.autocomplete(search, 100).then(items => this.products = items)

        this.status = item => [item.locationAcceptance, item.transportAcceptance].filter(Boolean).every(acceptance => acceptance.status === 'ACCEPTED') ? 'CONFIRMED' : 'PENDING'

        this.updateSummaries = () => {
            this.summaries = this.items.reduce((summaries, item) => {
                const product = item.product
                const unit = item.product && item.product.defaultUnit
                if (!product || !unit) return summaries
                const key = product.id + ':' + unit.id
                let summary = summaries.find(existing => existing.key === key)
                if (!summary) {
                    summary = {key: key, product: product, unit: unit, quantity: 0}
                    summaries.push(summary)
                }
                summary.quantity = Math.round((summary.quantity + Number(item.quantityOrdered || 0)) * 100) / 100
                return summaries
            }, [])
        }

        this.buildOrders = () => this.items.map(item => ({
            location: angular.copy(item.location),
            locationAcceptance: angular.copy(item.locationAcceptance),
            nodes: angular.copy(item.nodes),
            client: angular.copy(this.shared.client),
            clientStatusAcceptance: angular.copy(this.shared.clientStatusAcceptance),
            deliveryAddress: angular.copy(this.shared.deliveryAddress),
            deliveryTime: this.shared.deliveryTime,
            product: angular.copy(item.product),
            quantityOrdered: item.quantityOrdered,
            technologyRequirements: angular.copy(item.technologyRequirements),
            transport: angular.copy(item.transport),
            transportAcceptance: angular.copy(item.transportAcceptance),
            notes: item.notes
        }))

        this.save = () => ManufacturingOrder.batch({orders: this.buildOrders()}).$promise.then(orderIds => {
            $rootScope.$broadcast('manufacturing-order.updated')
            $uibModalInstance.close(orderIds)
        })

        $scope.$watch('$ctrl.shared.deliveryTime', (deliveryTime, previousDeliveryTime) => {
            if (deliveryTime === previousDeliveryTime) return
            this.checkVehicleConflicts()
        })

        this.cancel = () => $uibModalInstance.dismiss('cancel')
    })
